import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getDictsServiceTypesStatuses} = api.dicts;

const getDictsServiceTypesStatusesRefresh = atom<number>({
  key: 'getDictsServiceTypesStatusesRefresh',
  default: 0,
});

const getDictsServiceTypesStatusesQuery = selectorFamily({
  key: 'getDictsServiceTypesStatuses',
  get(params: Parameters<typeof getDictsServiceTypesStatuses>[0]) {
    return async ({get}) => {
      get(getDictsServiceTypesStatusesRefresh);
      try {
        const {data} = await getDictsServiceTypesStatuses(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetDictsServiceTypesStatusesQuery = createQuery(
  getDictsServiceTypesStatusesQuery,
  getDictsServiceTypesStatusesRefresh,
);
